// @generated by protoc-gen-es v1.7.2
// @generated from file tendermint/crypto/keys.proto (package tendermint.crypto, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * PublicKey defines the keys available for use with Validators
 *
 * @generated from message tendermint.crypto.PublicKey
 */
export const PublicKey = proto3.makeMessageType(
  "tendermint.crypto.PublicKey",
  () => [
    { no: 1, name: "ed25519", kind: "scalar", T: 12 /* ScalarType.BYTES */, oneof: "sum" },
    { no: 2, name: "secp256k1", kind: "scalar", T: 12 /* ScalarType.BYTES */, oneof: "sum" },
  ],
);

